import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const industries = [
    { slug: 'personal', titleKey: 'industries.personal' },
    { slug: 'business', titleKey: 'industries.business' },
    { slug: 'gov', titleKey: 'industries.gov' },
    { slug: 'learning', titleKey: 'industries.learning' },
    { slug: 'ai', titleKey: 'industries.ai' },
];

const IndustryNav = ({ currentSlug, lang }) => {
    const { t } = useTranslation();
    const index = industries.findIndex(s => s.slug === currentSlug);
    const prev = industries[(index - 1 + industries.length) % industries.length];
    const next = industries[(index + 1) % industries.length];

    return (
        <>
            <Link
                to={`/${lang}/industries/${prev.slug}`}
                className="pd-nav pd-nav-prev"
            >
                <span className="pd-nav-icon"><i className="fas fa-arrow-left"></i></span>
                <span className="pd-nav-label">
                    <small>PREVIOUS</small>
                    <strong>{t(prev.titleKey)}</strong>
                </span>
            </Link>
            <Link
                to={`/${lang}/industries/${next.slug}`}
                className="pd-nav pd-nav-next"
            >
                <span className="pd-nav-label">
                    <small>NEXT</small>
                    <strong>{t(next.titleKey)}</strong>
                </span>
                <span className="pd-nav-icon"><i className="fas fa-arrow-right"></i></span>
            </Link>
        </>
    );
};

export default IndustryNav;
